import React, { useState } from "react";
import FontAwesome from 'react-fontawesome';
import { withTranslation } from "react-i18next";
import {
    Dropdown, DropdownMenu, DropdownToggle
} from "reactstrap";
import { Modules } from "src/sdk";
import { Organisation } from "src/sdk/models/Organisation";

export interface DropdownOrganisationProps {
    values?: Organisation;
    fieldsOrganisation?: (values: Organisation) => void;
    usersOrganisation?: (values: Organisation) => void;
    onEditOrganisation?: (values: Organisation) => void;
    id?: number;
    onDeleteOrganisation?: (id: number) => void;
}

const DropdownOrganisation: React.FC<DropdownOrganisationProps> = ({
    values,
    fieldsOrganisation,
    usersOrganisation,
    onEditOrganisation,
}) => {
    const [menu, setMenu] = useState<boolean>(false);
    const [name, setName] = useState("Options");

    const fields = () => {
        if (fieldsOrganisation) fieldsOrganisation(values as Modules);
    };

    const users = () => {
        if (usersOrganisation) usersOrganisation(values as Modules);
    };

    const editOrganisation = () => {
        if (onEditOrganisation) onEditOrganisation(values as Modules);
    };

    return (
        <React.Fragment>
            <Dropdown
                isOpen={menu}
                toggle={() => setMenu(!menu)}
                className="d-inline-block"
            >
                <DropdownToggle
                    className="btn header-item bg-soft-light"
                    id="page-header-user-dropdown"
                    tag="button"
                >
                    <FontAwesome name="caret-down" />
                    <span className="d-none d-xl-inline-block ms-2 me-1">{name}</span>
                </DropdownToggle>
                <DropdownMenu
                    className="dropdown-menu-end"
                    style={{ width: "150px" }}
                    container="body"
                >
                    <div className="dropdown-item" onClick={fields}>
                        <i className="bx bx-user font-size-16 align-middle me-1" />
                        <span>Fields</span>
                    </div>
                    <div className="dropdown-item" onClick={users}>
                        <i className="bx bx-user font-size-16 align-middle me-1" />
                        <span>Users</span>
                    </div>
                    <div className="dropdown-item" onClick={editOrganisation}>
                        <i className="bx bx-user font-size-16 align-middle me-1" />
                        <span>Edit</span>
                    </div>                   
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

DropdownOrganisation.propTypes = {

};
export default withTranslation()(DropdownOrganisation);
